import { Injectable } from '@angular/core';
import { Subject, PartialObserver } from 'rxjs';

interface InvalidField {
	filterId: string;
}

@Injectable(
	{ providedIn: 'root' }
)
export class DatacenterFilterValidationService {
	invalidFields: InvalidField[] = [];
	private readonly isValidSubject: Subject<boolean> = new Subject<boolean>();

	setInvalidField(filterId: string) {
		this.invalidFields.push({ filterId });
		this.refreshView();
	}

	removeInvalidField(filterId: string) {
		this.invalidFields = this.invalidFields
			.filter((invalidField: InvalidField) => invalidField.filterId !== filterId);
		this.refreshView();
	}

	getInvalidField() {
		return this.invalidFields;
	}

	getIsValidObs(observer: PartialObserver<boolean>) {
		return this.isValidSubject.subscribe(observer);
	}

	isFiltersValid() {
		return this.invalidFields.length === 0;
	}

	refreshView() {
		this.isValidSubject.next(this.isFiltersValid());
	}
}
